const y = "vue2";
function u() {
  return typeof window < "u" && typeof document < "u";
}
const w = {};
function z(t, e) {
  let n = w[t];
  if (n || (n = w[t] = []), n.push(e), u()) {
    const o = {
      type: "builder.register",
      data: {
        type: t,
        info: e
      }
    };
    try {
      parent.postMessage(o, "*"), parent !== window && window.postMessage(o, "*");
    } catch (s) {
      console.debug("Could not postmessage", s);
    }
  }
}
const q = () => {
  z("insertMenu", {
    name: "_default",
    default: !0,
    items: [
      { name: "Box" },
      { name: "Text" },
      { name: "Image" },
      { name: "Columns" },
      { name: "Core:Section" },
      { name: "Core:Button" },
      { name: "Embed" },
      { name: "Custom Code" }
    ]
  });
}, K = () => {
  var t;
  u() && ((t = window.parent) == null || t.postMessage(
    {
      type: "builder.sdkInfo",
      data: {
        target: y,
        supportsPatchUpdates: !1,
        supportsAddBlockScoping: !0
      }
    },
    "*"
  ), window.addEventListener("message", ({ data: e }) => {
    var n, o;
    if (!!(e != null && e.type))
      switch (e.type) {
        case "builder.evaluate": {
          const s = e.data.text, r = e.data.arguments || [], a = e.data.id, c = new Function(s);
          let i, l = null;
          try {
            i = c.apply(null, r);
          } catch (d) {
            l = d;
          }
          l ? (n = window.parent) == null || n.postMessage(
            {
              type: "builder.evaluateError",
              data: { id: a, error: l.message }
            },
            "*"
          ) : i && typeof i.then == "function" ? i.then((d) => {
            var h;
            (h = window.parent) == null || h.postMessage(
              {
                type: "builder.evaluateResult",
                data: { id: a, result: d }
              },
              "*"
            );
          }).catch(console.error) : (o = window.parent) == null || o.postMessage(
            {
              type: "builder.evaluateResult",
              data: { result: i, id: a }
            },
            "*"
          );
          break;
        }
      }
  }));
};
function x(t) {
  return t;
}
function cn(t) {
  return t;
}
const D = () => Promise.resolve().then(() => N).then((t) => t.default).catch((t) => {
  throw console.error(
    "Error while attempting to dynamically import component RenderBlocks at ../../components/render-blocks.vue",
    t
  ), t;
}), J = {
  name: "builder-columns",
  components: { RenderBlocks: D },
  props: [
    "space",
    "columns",
    "stackColumnsAt",
    "reverseColumnsWhenStacked",
    "builderBlock"
  ],
  data: () => ({ markMutable: x }),
  computed: {
    columnsCssVars() {
      const t = this.stackColumnsAt === "never" ? "inherit" : this.reverseColumnsWhenStacked ? "column-reverse" : "column";
      return {
        "--flex-dir": t,
        "--flex-dir-tablet": this.maybeApplyForTablet(t)
      };
    },
    columnCssVars() {
      const t = "100%", e = "0";
      return {
        "--column-width": t,
        "--column-margin-left": e,
        "--column-width-tablet": this.maybeApplyForTablet(t),
        "--column-margin-left-tablet": this.maybeApplyForTablet(e)
      };
    }
  },
  methods: {
    getGutterSize() {
      return typeof this.space == "number" ? this.space || 0 : 20;
    },
    getColumns() {
      return this.columns || [];
    },
    getWidth(t) {
      var n;
      const e = this.getColumns();
      return ((n = e[t]) == null ? void 0 : n.width) || 100 / e.length;
    },
    getColumnCssWidth(t) {
      const e = this.getColumns(), o = this.getGutterSize() * (e.length - 1) / e.length;
      return `calc(${this.getWidth(t)}% - ${o}px)`;
    },
    maybeApplyForTablet(t) {
      return (this.stackColumnsAt || "tablet") === "tablet" ? t : "inherit";
    }
  }
};
function p(t, e, n, o, s, r, a, c) {
  var i = typeof t == "function" ? t.options : t;
  e && (i.render = e, i.staticRenderFns = n, i._compiled = !0), o && (i.functional = !0), r && (i._scopeId = "data-v-" + r);
  var l;
  if (a ? (l = function(m) {
    m = m || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !m && typeof __VUE_SSR_CONTEXT__ < "u" && (m = __VUE_SSR_CONTEXT__), s && s.call(this, m), m && m._registeredComponents && m._registeredComponents.add(a);
  }, i._ssrRegister = l) : s && (l = c ? function() {
    s.call(
      this,
      (i.functional ? this.parent : this).$root.$options.shadowRoot
    );
  } : s), l)
    if (i.functional) {
      i._injectStyles = l;
      var d = i.render;
      i.render = function(H, k) {
        return l.call(k), d(H, k);
      };
    } else {
      var h = i.beforeCreate;
      i.beforeCreate = h ? [].concat(h, l) : [l];
    }
  return {
    exports: t,
    options: i
  };
}
var G = function() {
  var e = this, n = e._self._c;
  return n("div", { staticClass: "builder-columns div-t9spj7joih", style: e.columnsCssVars }, e._l(e.columns, function(o, s) {
    return n("div", { key: s, staticClass: "builder-column div-t9spj7joih-2", style: {
      width: e.getColumnCssWidth(s),
      marginLeft: `${s === 0 ? 0 : e.getGutterSize()}px`,
      ...e.columnCssVars
    } }, [n("render-blocks", { attrs: { blocks: e.markMutable(o.blocks), path: `component.options.columns.${s}.blocks`, parent: e.builderBlock.id, styleProp: {
      flexGrow: "1"
    } } })], 1);
  }), 0);
}, X = [], Y = /* @__PURE__ */ p(
  J,
  G,
  X,
  !1,
  null,
  "634e4254",
  null,
  null
);
const Q = Y.exports;
function S(t) {
  return t.replace(/http(s)?:/, "");
}
function Z(t = "", e, n) {
  const o = new RegExp("([?&])" + e + "=.*?(&|$)", "i"), s = t.indexOf("?") !== -1 ? "&" : "?";
  return t.match(o) ? t.replace(o, "$1" + e + "=" + encodeURIComponent(n) + "$2") : t + s + e + "=" + encodeURIComponent(n);
}
function ee(t, e) {
  if (!t || !(t != null && t.match(/cdn\.shopify\.com/)) || !e)
    return t;
  if (e === "master")
    return S(t);
  const n = t.match(
    /(_\d+x(\d+)?)?(\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?)/i
  );
  if (n) {
    const o = t.split(n[0]), s = n[3], r = e.match("x") ? e : `${e}x`;
    return S(`${o[0]}_${r}${s}`);
  }
  return null;
}
function b(t) {
  if (!t)
    return t;
  const e = [100, 200, 400, 800, 1200, 1600, 2e3];
  if (t.match(/builder\.io/)) {
    let n = t;
    const o = Number(t.split("?width=")[1]);
    return isNaN(o) || (n = `${n} ${o}w`), e.filter((s) => s !== o).map((s) => `${Z(t, "width", s)} ${s}w`).concat([n]).join(", ");
  }
  return t.match(/cdn\.shopify\.com/) ? e.map((n) => [ee(t, `${n}x${n}`), n]).filter(([n]) => !!n).map(([n, o]) => `${n} ${o}w`).concat([t]).join(", ") : t;
}
const te = {
  name: "builder-image",
  props: [
    "image",
    "src",
    "srcset",
    "noWebp",
    "altText",
    "backgroundSize",
    "className",
    "sizes",
    "aspectRatio",
    "builderBlock",
    "fitContent"
  ],
  computed: {
    srcSetToUse() {
      var n;
      const e = this.image || this.src;
      if (!e || !(e.match(/builder\.io/) || e.match(/cdn\.shopify\.com/)))
        return this.srcset;
      if (this.srcset && ((n = this.image) == null ? void 0 : n.includes("builder.io/api/v1/image"))) {
        if (!this.srcset.includes(this.image.split("?")[0]))
          return console.debug("Removed given srcset"), b(e);
      } else if (this.image && !this.srcset)
        return b(e);
      return b(e);
    },
    webpSrcSet() {
      var t;
      return ((t = this.srcSetToUse) == null ? void 0 : t.match(/builder\.io/)) && !this.noWebp ? this.srcSetToUse.replace(/\?/g, "?format=webp&") : "";
    }
  },
  methods: {
    _classStringToObject(t) {
      const e = {};
      if (typeof t != "string")
        return e;
      const n = t.trim().split(/\s+/);
      for (const o of n)
        e[o] = !0;
      return e;
    }
  }
};
var ne = function() {
  var o, s, r, a;
  var e = this, n = e._self._c;
  return n("div", [n("picture", [e.webpSrcSet ? [n("source", { attrs: { type: "image/webp", srcset: e.webpSrcSet } })] : e._e(), n("img", { class: e._classStringToObject(
    "builder-image" + (e.className ? " " + e.className : "") + " img-1j57pcfa436"
  ), style: {
    objectPosition: e.backgroundSize || "center",
    objectFit: e.backgroundSize || "cover"
  }, attrs: { loading: "lazy", alt: e.altText, role: e.altText ? "presentation" : void 0, src: e.image, srcset: e.srcSetToUse, sizes: e.sizes } }), n("source", { attrs: { srcset: e.srcSetToUse } })], 2), e.aspectRatio && !(((s = (o = e.builderBlock) == null ? void 0 : o.children) == null ? void 0 : s.length) && e.fitContent) ? [n("div", { staticClass: "builder-image-sizer div-1j57pcfa436", style: {
    paddingTop: e.aspectRatio * 100 + "%"
  } })] : e._e(), ((a = (r = e.builderBlock) == null ? void 0 : r.children) == null ? void 0 : a.length) && e.fitContent ? [e._t("default")] : e._e(), !e.fitContent && e.children ? [n("div", { staticClass: "div-1j57pcfa436-2" }, [e._t("default")], 2)] : e._e()], 2);
}, oe = [], se = /* @__PURE__ */ p(
  te,
  ne,
  oe,
  !1,
  null,
  "c75d9535",
  null,
  null
);
const re = se.exports, ae = {
  name: "builder-text",
  props: ["text"]
};
var ie = function() {
  var e = this, n = e._self._c;
  return n("span", { staticClass: "builder-text", domProps: { innerHTML: e._s(e.text) } });
}, ce = [], le = /* @__PURE__ */ p(
  ae,
  ie,
  ce,
  !1,
  null,
  null,
  null,
  null
);
const de = le.exports, ue = {
  name: "builder-video",
  props: [
    "autoPlay",
    "muted",
    "controls",
    "loop",
    "playsInline",
    "attributes",
    "fit",
    "position",
    "video",
    "posterImage"
  ],
  computed: {
    videoProps() {
      return {
        ...this.autoPlay === !0 ? {
          autoPlay: !0
        } : {},
        ...this.muted === !0 ? {
          muted: !0
        } : {},
        ...this.controls === !0 ? {
          controls: !0
        } : {},
        ...this.loop === !0 ? {
          loop: !0
        } : {},
        ...this.playsInline === !0 ? {
          playsInline: !0
        } : {}
      };
    },
    spreadProps() {
      return {
        ...this.attributes,
        ...this.videoProps
      };
    }
  }
};
var pe = function() {
  var o;
  var e = this, n = e._self._c;
  return n("video", e._b({ style: {
    width: "100%",
    height: "100%",
    ...(o = e.attributes) == null ? void 0 : o.style,
    objectFit: e.fit,
    objectPosition: e.position,
    borderRadius: 1
  }, attrs: { src: e.video || "no-src", poster: e.posterImage } }, "video", e.spreadProps, !1));
}, me = [], he = /* @__PURE__ */ p(
  ue,
  pe,
  me,
  !1,
  null,
  null,
  null,
  null
);
const fe = he.exports;
function v(t, e = null, n = ".") {
  return Object.keys(t).reduce((o, s) => {
    const r = t[s], a = [e, s].filter(Boolean).join(n);
    return [
      typeof r == "object",
      r !== null,
      !(Array.isArray(r) && r.length === 0)
    ].every(Boolean) ? { ...o, ...v(r, a, n) } : { ...o, [a]: r };
  }, {});
}
const I = "builder.", ge = (t) => {
  const e = {};
  return t.forEach((n, o) => {
    e[o] = n;
  }), e;
}, be = (t) => {
  if (!t)
    return {};
  const e = E(t), n = {};
  return Object.keys(e).forEach((o) => {
    if (o.startsWith(I)) {
      const s = o.replace(I, "");
      n[s] = e[o];
    }
  }), n;
}, ve = () => {
  if (!u())
    return {};
  const t = new URLSearchParams(window.location.search);
  return be(t);
}, E = (t) => t instanceof URLSearchParams ? ge(t) : t;
function _e() {
  return typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : null;
}
async function F() {
  const t = _e().fetch;
  if (typeof t > "u" && typeof global < "u") {
    const e = import("node-fetch").then((n) => n.default);
    return e.default || e;
  }
  return t.default || t;
}
const ye = (t) => {
  const e = t.split(".");
  return e.length > 2 ? e.slice(1).join(".") : t;
}, j = async ({
  name: t,
  canTrack: e
}) => {
  var n;
  try {
    return e ? (n = document.cookie.split("; ").find((o) => o.startsWith(`${t}=`))) == null ? void 0 : n.split("=")[1] : void 0;
  } catch (o) {
    console.debug("[COOKIE] GET error: ", o);
  }
}, xe = (t) => t.map(([e, n]) => n ? `${e}=${n}` : e).join("; "), Ce = [
  ["secure", ""],
  ["SameSite", "None"]
], ke = ({
  name: t,
  value: e,
  expires: n
}) => {
  const s = (u() ? location.protocol === "https:" : !0) ? Ce : [[]], r = n ? [["expires", n.toUTCString()]] : [[]], a = [
    [t, e],
    ...r,
    ["path", "/"],
    ["domain", ye(window.location.hostname)],
    ...s
  ];
  return xe(a);
}, U = async ({
  name: t,
  value: e,
  expires: n,
  canTrack: o
}) => {
  try {
    if (!o)
      return;
    const s = ke({ name: t, value: e, expires: n });
    document.cookie = s;
  } catch (s) {
    console.warn("[COOKIE] SET error: ", s);
  }
}, we = "builderio.variations", V = (t) => `${we}.${t}`, Se = ({
  contentId: t,
  canTrack: e
}) => j({ name: V(t), canTrack: e }), Ie = ({
  contentId: t,
  canTrack: e,
  value: n
}) => U({ name: V(t), value: n, canTrack: e }), g = (t) => t != null, Te = (t) => g(t.id) && g(t.variations) && Object.keys(t.variations).length > 0, Re = ({
  id: t,
  variations: e
}) => {
  var s;
  let n = 0;
  const o = Math.random();
  for (const r in e)
    if (n += (s = e[r]) == null ? void 0 : s.testRatio, o < n)
      return r;
  return t;
}, T = ({
  item: t,
  testGroupId: e
}) => {
  const n = t.variations[e];
  return e === t.id || !n ? {
    testVariationId: t.id,
    testVariationName: "Default"
  } : {
    data: n.data,
    testVariationId: n.id,
    testVariationName: n.name || (n.id === t.id ? "Default" : "")
  };
}, $e = async ({
  item: t,
  canTrack: e
}) => {
  const n = await Se({
    canTrack: e,
    contentId: t.id
  }), o = n ? T({ item: t, testGroupId: n }) : void 0;
  if (o)
    return o;
  {
    const s = Re({
      variations: t.variations,
      id: t.id
    });
    return Ie({
      contentId: t.id,
      value: s,
      canTrack: e
    }).catch((r) => {
      console.error("could not store A/B test variation: ", r);
    }), T({ item: t, testGroupId: s });
  }
}, Ee = async ({
  item: t,
  canTrack: e
}) => {
  if (!Te(t))
    return;
  const n = await $e({ item: t, canTrack: e });
  Object.assign(t, n);
};
async function A(t) {
  return (await je({ ...t, limit: 1 })).results[0] || null;
}
const Fe = (t) => {
  const {
    limit: e = 30,
    userAttributes: n,
    query: o,
    noTraverse: s = !1,
    model: r,
    apiKey: a
  } = t, c = new URL(
    `https://cdn.builder.io/api/v2/content/${r}?apiKey=${a}&limit=${e}&noTraverse=${s}`
  ), i = {
    ...ve(),
    ...E(t.options || {})
  }, l = v(i);
  for (const d in l)
    c.searchParams.set(d, String(l[d]));
  if (n && c.searchParams.set("userAttributes", JSON.stringify(n)), o) {
    const d = v({ query: o });
    for (const h in d)
      c.searchParams.set(h, JSON.stringify(d[h]));
  }
  return c;
};
async function je(t) {
  const e = Fe(t), o = await (await F())(e.href).then(
    (r) => r.json()
  ), s = t.canTrack !== !1;
  if (s)
    for (const r of o.results)
      await Ee({ item: r, canTrack: s });
  return o;
}
const Ue = () => Promise.resolve().then(() => Zt).then((t) => t.default).catch((t) => {
  throw console.error(
    "Error while attempting to dynamically import component RenderContent at ../../components/render-content/render-content.vue",
    t
  ), t;
}), Ve = {
  name: "builder-symbol",
  components: { RenderContent: Ue },
  props: ["symbol", "attributes"],
  data: () => ({
    className: "builder-symbol",
    fetchedContent: null,
    markMutable: x
  }),
  inject: {
    builderContext: "BuilderContext"
  },
  watch: {
    onUpdateHook0() {
      const t = this.symbol;
      t && !t.content && !this.fetchedContent && t.model && A({
        model: t.model,
        apiKey: this.builderContext.apiKey,
        query: {
          id: t.entry
        }
      }).then((e) => {
        this.fetchedContent = e;
      });
    }
  },
  computed: {
    contentToUse() {
      var t;
      return ((t = this.symbol) == null ? void 0 : t.content) || this.fetchedContent;
    },
    onUpdateHook0() {
      return {
        0: this.symbol,
        1: this.fetchedContent
      };
    }
  },
  methods: {
    _classStringToObject(t) {
      const e = {};
      if (typeof t != "string")
        return e;
      const n = t.trim().split(/\s+/);
      for (const o of n)
        e[o] = !0;
      return e;
    }
  }
};
var Ae = function() {
  var o, s, r, a, c;
  var e = this, n = e._self._c;
  return n("div", e._b({ class: e._classStringToObject(e.className), attrs: { dataSet: {
    class: e.className
  } } }, "div", e.attributes, !1), [n("render-content", { attrs: { apiKey: e.builderContext.apiKey, context: e.builderContext.context, customComponents: e.markMutable(Object.values(e.builderContext.registeredComponents)), data: e.markMutable({
    ...(o = e.symbol) == null ? void 0 : o.data,
    ...e.builderContext.state,
    ...(a = (r = (s = e.symbol) == null ? void 0 : s.content) == null ? void 0 : r.data) == null ? void 0 : a.state
  }), model: (c = e.symbol) == null ? void 0 : c.model, content: e.markMutable(e.contentToUse) } })], 1);
}, Oe = [], Pe = /* @__PURE__ */ p(
  Ve,
  Ae,
  Oe,
  !1,
  null,
  null,
  null,
  null
);
const We = Pe.exports, Be = {
  name: "builder-button",
  props: ["attributes", "text", "link", "openLinkInNewTab"]
};
var Le = function() {
  var e = this, n = e._self._c;
  return e.link ? n("a", e._b({ attrs: { role: "button", href: e.link, target: e.openLinkInNewTab ? "_blank" : void 0 } }, "a", e.attributes, !1), [e._v(" " + e._s(e.text) + " ")]) : n("button", e._b({ staticClass: "button-2fnk003dqad" }, "button", e.attributes, !1), [e._v(" " + e._s(e.text) + " ")]);
}, Me = [], Ne = /* @__PURE__ */ p(
  Be,
  Le,
  Me,
  !1,
  null,
  "490b8c29",
  null,
  null
);
const He = Ne.exports, ze = {
  name: "builder-section-component",
  props: ["attributes", "maxWidth"]
};
var qe = function() {
  var e = this, n = e._self._c;
  return n("section", e._b({ style: e.maxWidth && typeof e.maxWidth == "number" ? {
    maxWidth: e.maxWidth
  } : void 0 }, "section", e.attributes, !1), [e._t("default")], 2);
}, Ke = [], De = /* @__PURE__ */ p(
  ze,
  qe,
  Ke,
  !1,
  null,
  null,
  null,
  null
);
const Je = De.exports, Ge = {
  name: "builder-fragment-component",
  props: []
};
var Xe = function() {
  var e = this, n = e._self._c;
  return n("span", [e._t("default")], 2);
}, Ye = [], Qe = /* @__PURE__ */ p(
  Ge,
  Xe,
  Ye,
  !1,
  null,
  null,
  null,
  null
);
const Ze = Qe.exports, et = {
  name: "Core:Button",
  builtIn: !0,
  image: "https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2F81a15681c3e74df09677dfc57a615b13",
  defaultStyles: {
    appearance: "none",
    paddingTop: "15px",
    paddingBottom: "15px",
    paddingLeft: "25px",
    paddingRight: "25px",
    backgroundColor: "#000000",
    color: "white",
    borderRadius: "4px",
    textAlign: "center",
    cursor: "pointer"
  },
  inputs: [
    {
      name: "text",
      type: "text",
      defaultValue: "Click me!",
      bubble: !0
    },
    {
      name: "link",
      type: "url",
      bubble: !0
    },
    {
      name: "openLinkInNewTab",
      type: "boolean",
      defaultValue: !1,
      friendlyName: "Open link in new tab"
    }
  ],
  static: !0,
  noWrap: !0
};
function C(t) {
  return t.__qwik_serializable__ = !0, t;
}
const tt = {
  name: "Columns",
  builtIn: !0,
  inputs: [
    {
      name: "columns",
      type: "array",
      broadcast: !0,
      subFields: [
        {
          name: "blocks",
          type: "array",
          hideFromUI: !0,
          defaultValue: [
            {
              "@type": "@builder.io/sdk:Element",
              responsiveStyles: {
                large: {
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "stretch",
                  flexShrink: "0",
                  position: "relative",
                  marginTop: "30px",
                  textAlign: "center",
                  lineHeight: "normal",
                  height: "auto",
                  minHeight: "20px",
                  minWidth: "20px",
                  overflow: "hidden"
                }
              },
              component: {
                name: "Image",
                options: {
                  image: "https://builder.io/api/v1/image/assets%2Fpwgjf0RoYWbdnJSbpBAjXNRMe9F2%2Ffb27a7c790324294af8be1c35fe30f4d",
                  backgroundPosition: "center",
                  backgroundSize: "cover",
                  aspectRatio: 0.7004048582995948
                }
              }
            },
            {
              "@type": "@builder.io/sdk:Element",
              responsiveStyles: {
                large: {
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "stretch",
                  flexShrink: "0",
                  position: "relative",
                  marginTop: "30px",
                  textAlign: "center",
                  lineHeight: "normal",
                  height: "auto"
                }
              },
              component: {
                name: "Text",
                options: {
                  text: "<p>Enter some text...</p>"
                }
              }
            }
          ]
        },
        {
          name: "width",
          type: "number",
          hideFromUI: !0,
          helperText: "Width %, e.g. set to 50 to fill half of the space"
        },
        {
          name: "link",
          type: "url",
          helperText: "Optionally set a url that clicking this column will link to"
        }
      ],
      defaultValue: [
        {
          blocks: [
            {
              "@type": "@builder.io/sdk:Element",
              responsiveStyles: {
                large: {
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "stretch",
                  flexShrink: "0",
                  position: "relative",
                  marginTop: "30px",
                  textAlign: "center",
                  lineHeight: "normal",
                  height: "auto",
                  minHeight: "20px",
                  minWidth: "20px",
                  overflow: "hidden"
                }
              },
              component: {
                name: "Image",
                options: {
                  image: "https://builder.io/api/v1/image/assets%2Fpwgjf0RoYWbdnJSbpBAjXNRMe9F2%2Ffb27a7c790324294af8be1c35fe30f4d",
                  backgroundPosition: "center",
                  backgroundSize: "cover",
                  aspectRatio: 0.7004048582995948
                }
              }
            },
            {
              "@type": "@builder.io/sdk:Element",
              responsiveStyles: {
                large: {
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "stretch",
                  flexShrink: "0",
                  position: "relative",
                  marginTop: "30px",
                  textAlign: "center",
                  lineHeight: "normal",
                  height: "auto"
                }
              },
              component: {
                name: "Text",
                options: {
                  text: "<p>Enter some text...</p>"
                }
              }
            }
          ]
        },
        {
          blocks: [
            {
              "@type": "@builder.io/sdk:Element",
              responsiveStyles: {
                large: {
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "stretch",
                  flexShrink: "0",
                  position: "relative",
                  marginTop: "30px",
                  textAlign: "center",
                  lineHeight: "normal",
                  height: "auto",
                  minHeight: "20px",
                  minWidth: "20px",
                  overflow: "hidden"
                }
              },
              component: {
                name: "Image",
                options: {
                  image: "https://builder.io/api/v1/image/assets%2Fpwgjf0RoYWbdnJSbpBAjXNRMe9F2%2Ffb27a7c790324294af8be1c35fe30f4d",
                  backgroundPosition: "center",
                  backgroundSize: "cover",
                  aspectRatio: 0.7004048582995948
                }
              }
            },
            {
              "@type": "@builder.io/sdk:Element",
              responsiveStyles: {
                large: {
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "stretch",
                  flexShrink: "0",
                  position: "relative",
                  marginTop: "30px",
                  textAlign: "center",
                  lineHeight: "normal",
                  height: "auto"
                }
              },
              component: {
                name: "Text",
                options: {
                  text: "<p>Enter some text...</p>"
                }
              }
            }
          ]
        }
      ],
      onChange: C((t) => {
        function e() {
          n.forEach((o) => {
            o.delete("width");
          });
        }
        const n = t.get("columns");
        Array.isArray(n) && !!n.find(
          (s) => s.get("width")
        ) && (!!n.find(
          (r) => !r.get("width")
        ) || n.reduce((c, i) => c + i.get("width"), 0) !== 100) && e();
      })
    },
    {
      name: "space",
      type: "number",
      defaultValue: 20,
      helperText: "Size of gap between columns",
      advanced: !0
    },
    {
      name: "stackColumnsAt",
      type: "string",
      defaultValue: "tablet",
      helperText: "Convert horizontal columns to vertical at what device size",
      enum: ["tablet", "mobile", "never"],
      advanced: !0
    },
    {
      name: "reverseColumnsWhenStacked",
      type: "boolean",
      defaultValue: !1,
      helperText: "When stacking columns for mobile devices, reverse the ordering",
      advanced: !0
    }
  ]
}, nt = {
  name: "Fragment",
  static: !0,
  hidden: !0,
  builtIn: !0,
  canHaveChildren: !0,
  noWrap: !0
}, ot = {
  name: "Image",
  static: !0,
  builtIn: !0,
  image: "https://firebasestorage.googleapis.com/v0/b/builder-3b0a2.appspot.com/o/images%2Fbaseline-insert_photo-24px.svg?alt=media&token=4e5d0ef4-f5e8-4e57-b3a9-38d63a9b9dc4",
  defaultStyles: {
    position: "relative",
    minHeight: "20px",
    minWidth: "20px",
    overflow: "hidden"
  },
  canHaveChildren: !0,
  inputs: [
    {
      name: "image",
      type: "file",
      bubble: !0,
      allowedFileTypes: ["jpeg", "jpg", "png", "svg"],
      required: !0,
      defaultValue: "https://cdn.builder.io/api/v1/image/assets%2Fpwgjf0RoYWbdnJSbpBAjXNRMe9F2%2Ffb27a7c790324294af8be1c35fe30f4d",
      onChange: C((t) => {
        t.delete("srcset"), t.delete("noWebp");
        function n(a, c = 6e4) {
          return new Promise((i, l) => {
            const d = document.createElement("img");
            let h = !1;
            d.onload = () => {
              h = !0, i(d);
            }, d.addEventListener("error", (m) => {
              console.warn("Image load failed", m.error), l(m.error);
            }), d.src = a, setTimeout(() => {
              h || l(new Error("Image load timed out"));
            }, c);
          });
        }
        function o(a) {
          return Math.round(a * 1e3) / 1e3;
        }
        const s = t.get("image"), r = t.get("aspectRatio");
        if (fetch(s).then((a) => a.blob()).then((a) => {
          a.type.includes("svg") && t.set("noWebp", !0);
        }), s && (!r || r === 0.7041))
          return n(s).then((a) => {
            const c = t.get("aspectRatio");
            t.get("image") === s && (!c || c === 0.7041) && a.width && a.height && (t.set("aspectRatio", o(a.height / a.width)), t.set("height", a.height), t.set("width", a.width));
          });
      })
    },
    {
      name: "backgroundSize",
      type: "text",
      defaultValue: "cover",
      enum: [
        {
          label: "contain",
          value: "contain",
          helperText: "The image should never get cropped"
        },
        {
          label: "cover",
          value: "cover",
          helperText: "The image should fill it's box, cropping when needed"
        }
      ]
    },
    {
      name: "backgroundPosition",
      type: "text",
      defaultValue: "center",
      enum: [
        "center",
        "top",
        "left",
        "right",
        "bottom",
        "top left",
        "top right",
        "bottom left",
        "bottom right"
      ]
    },
    {
      name: "altText",
      type: "string",
      helperText: "Text to display when the user has images off"
    },
    {
      name: "height",
      type: "number",
      hideFromUI: !0
    },
    {
      name: "width",
      type: "number",
      hideFromUI: !0
    },
    {
      name: "sizes",
      type: "string",
      hideFromUI: !0
    },
    {
      name: "srcset",
      type: "string",
      hideFromUI: !0
    },
    {
      name: "lazy",
      type: "boolean",
      defaultValue: !0,
      hideFromUI: !0
    },
    {
      name: "fitContent",
      type: "boolean",
      helperText: "When child blocks are provided, fit to them instead of using the image's aspect ratio",
      defaultValue: !0
    },
    {
      name: "aspectRatio",
      type: "number",
      helperText: "This is the ratio of height/width, e.g. set to 1.5 for a 300px wide and 200px tall photo. Set to 0 to not force the image to maintain it's aspect ratio",
      advanced: !0,
      defaultValue: 0.7041
    }
  ]
}, st = {
  name: "Core:Section",
  static: !0,
  builtIn: !0,
  image: "https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2F682efef23ace49afac61748dd305c70a",
  inputs: [
    {
      name: "maxWidth",
      type: "number",
      defaultValue: 1200
    },
    {
      name: "lazyLoad",
      type: "boolean",
      defaultValue: !1,
      advanced: !0,
      description: "Only render this section when in view"
    }
  ],
  defaultStyles: {
    paddingLeft: "20px",
    paddingRight: "20px",
    paddingTop: "50px",
    paddingBottom: "50px",
    marginTop: "0px",
    width: "100vw",
    marginLeft: "calc(50% - 50vw)"
  },
  canHaveChildren: !0,
  defaultChildren: [
    {
      "@type": "@builder.io/sdk:Element",
      responsiveStyles: {
        large: {
          textAlign: "center"
        }
      },
      component: {
        name: "Text",
        options: {
          text: "<p><b>I am a section! My content keeps from getting too wide, so that it's easy to read even on big screens.</b></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur</p>"
        }
      }
    }
  ]
}, rt = {
  name: "Symbol",
  noWrap: !0,
  static: !0,
  builtIn: !0,
  inputs: [
    {
      name: "symbol",
      type: "uiSymbol"
    },
    {
      name: "dataOnly",
      helperText: "Make this a data symbol that doesn't display any UI",
      type: "boolean",
      defaultValue: !1,
      advanced: !0,
      hideFromUI: !0
    },
    {
      name: "inheritState",
      helperText: "Inherit the parent component state and data",
      type: "boolean",
      defaultValue: !1,
      advanced: !0
    },
    {
      name: "renderToLiquid",
      helperText: "Render this symbols contents to liquid. Turn off to fetch with javascript and use custom targeting",
      type: "boolean",
      defaultValue: !1,
      advanced: !0,
      hideFromUI: !0
    },
    {
      name: "useChildren",
      hideFromUI: !0,
      type: "boolean"
    }
  ]
}, at = {
  name: "Text",
  static: !0,
  builtIn: !0,
  image: "https://firebasestorage.googleapis.com/v0/b/builder-3b0a2.appspot.com/o/images%2Fbaseline-text_fields-24px%20(1).svg?alt=media&token=12177b73-0ee3-42ca-98c6-0dd003de1929",
  inputs: [
    {
      name: "text",
      type: "html",
      required: !0,
      autoFocus: !0,
      bubble: !0,
      defaultValue: "Enter some text..."
    }
  ],
  defaultStyles: {
    lineHeight: "normal",
    height: "auto",
    textAlign: "center"
  }
}, it = {
  name: "Video",
  canHaveChildren: !0,
  builtIn: !0,
  defaultStyles: {
    minHeight: "20px",
    minWidth: "20px"
  },
  image: "https://firebasestorage.googleapis.com/v0/b/builder-3b0a2.appspot.com/o/images%2Fbaseline-videocam-24px%20(1).svg?alt=media&token=49a84e4a-b20e-4977-a650-047f986874bb",
  inputs: [
    {
      name: "video",
      type: "file",
      allowedFileTypes: ["mp4"],
      bubble: !0,
      defaultValue: "https://firebasestorage.googleapis.com/v0/b/builder-3b0a2.appspot.com/o/assets%2FKQlEmWDxA0coC3PK6UvkrjwkIGI2%2F28cb070609f546cdbe5efa20e931aa4b?alt=media&token=912e9551-7a7c-4dfb-86b6-3da1537d1a7f",
      required: !0
    },
    {
      name: "posterImage",
      type: "file",
      allowedFileTypes: ["jpeg", "png"],
      helperText: "Image to show before the video plays"
    },
    {
      name: "autoPlay",
      type: "boolean",
      defaultValue: !0
    },
    {
      name: "controls",
      type: "boolean",
      defaultValue: !1
    },
    {
      name: "muted",
      type: "boolean",
      defaultValue: !0
    },
    {
      name: "loop",
      type: "boolean",
      defaultValue: !0
    },
    {
      name: "playsInline",
      type: "boolean",
      defaultValue: !0
    },
    {
      name: "fit",
      type: "text",
      defaultValue: "cover",
      enum: ["contain", "cover", "fill", "auto"]
    },
    {
      name: "fitContent",
      type: "boolean",
      helperText: "When child blocks are provided, fit to them instead of using the aspect ratio",
      defaultValue: !0,
      advanced: !0
    },
    {
      name: "position",
      type: "text",
      defaultValue: "center",
      enum: [
        "center",
        "top",
        "left",
        "right",
        "bottom",
        "top left",
        "top right",
        "bottom left",
        "bottom right"
      ]
    },
    {
      name: "height",
      type: "number",
      advanced: !0
    },
    {
      name: "width",
      type: "number",
      advanced: !0
    },
    {
      name: "aspectRatio",
      type: "number",
      advanced: !0,
      defaultValue: 0.7004048582995948
    },
    {
      name: "lazyLoad",
      type: "boolean",
      helperText: 'Load this video "lazily" - as in only when a user scrolls near the video. Recommended for optmized performance and bandwidth consumption',
      defaultValue: !0,
      advanced: !0
    }
  ]
}, ct = {
  name: "Embed",
  static: !0,
  builtIn: !0,
  inputs: [
    {
      name: "url",
      type: "url",
      required: !0,
      defaultValue: "",
      helperText: "e.g. enter a youtube url, google map, etc",
      onChange: C((t) => {
        const e = t.get("url");
        if (e)
          return t.set("content", "Loading..."), fetch(
            `https://iframe.ly/api/iframely?url=${e}&api_key=ae0e60e78201a3f2b0de4b`
          ).then((o) => o.json()).then((o) => {
            t.get("url") === e && (o.html ? t.set("content", o.html) : t.set("content", "Invalid url, please try another"));
          }).catch((o) => {
            t.set(
              "content",
              "There was an error embedding this URL, please try again or another URL"
            );
          });
        t.delete("content");
      })
    },
    {
      name: "content",
      type: "html",
      defaultValue: '<div style="padding: 20px; text-align: center">(Choose an embed URL)<div>',
      hideFromUI: !0
    }
  ]
}, lt = [
  "text/javascript",
  "application/javascript",
  "application/ecmascript"
], dt = (t) => lt.includes(t.type), ut = {
  name: "builder-embed",
  props: ["content"],
  data: () => ({ scriptsInserted: [], scriptsRun: [], ranInitFn: !1 }),
  watch: {
    onUpdateHook0() {
      this.$refs.elem && !this.ranInitFn && (this.ranInitFn = !0, this.findAndRunScripts());
    }
  },
  computed: {
    onUpdateHook0() {
      return {
        0: this.$refs.elem,
        1: this.ranInitFn
      };
    }
  },
  methods: {
    findAndRunScripts() {
      if (!this.$refs.elem || !this.$refs.elem.getElementsByTagName)
        return;
      const t = this.$refs.elem.getElementsByTagName("script");
      for (let e = 0; e < t.length; e++) {
        const n = t[e];
        if (n.src && !this.scriptsInserted.includes(n.src)) {
          this.scriptsInserted.push(n.src);
          const o = document.createElement("script");
          o.async = !0, o.src = n.src, document.head.appendChild(o);
        } else if (dt(n) && !this.scriptsRun.includes(n.innerText))
          try {
            this.scriptsRun.push(n.innerText), new Function(n.innerText)();
          } catch (o) {
            console.warn("`Embed`: Error running script:", o);
          }
      }
    }
  }
};
var pt = function() {
  var e = this, n = e._self._c;
  return n("div", { ref: "elem", staticClass: "builder-embed", domProps: { innerHTML: e._s(e.content) } });
}, mt = [], ht = /* @__PURE__ */ p(
  ut,
  pt,
  mt,
  !1,
  null,
  null,
  null,
  null
);
const ft = ht.exports;
function gt() {
  return u() && window.self !== window.top;
}
function f() {
  return gt() && window.location.search.indexOf("builder.frameEditing=") !== -1;
}
const bt = {
  name: "builder-img-component",
  props: [
    "backgroundSize",
    "backgroundPosition",
    "imgSrc",
    "altText",
    "image",
    "attributes"
  ],
  data: () => ({ isEditing: f })
};
var vt = function() {
  var e = this, n = e._self._c;
  return n("img", e._b({ key: e.isEditing() && e.imgSrc || "default-key", style: {
    objectFit: e.backgroundSize || "cover",
    objectPosition: e.backgroundPosition || "center"
  }, attrs: { alt: e.altText, src: e.imgSrc || e.image } }, "img", e.attributes, !1));
}, _t = [], yt = /* @__PURE__ */ p(
  bt,
  vt,
  _t,
  !1,
  null,
  null,
  null,
  null
);
const xt = yt.exports, Ct = {
  name: "Raw:Img",
  hideFromInsertMenu: !0,
  builtIn: !0,
  image: "https://firebasestorage.googleapis.com/v0/b/builder-3b0a2.appspot.com/o/images%2Fbaseline-insert_photo-24px.svg?alt=media&token=4e5d0ef4-f5e8-4e57-b3a9-38d63a9b9dc4",
  inputs: [
    {
      name: "image",
      bubble: !0,
      type: "file",
      allowedFileTypes: ["jpeg", "jpg", "png", "svg"],
      required: !0
    }
  ],
  noWrap: !0,
  static: !0
}, kt = {
  name: "builder-custom-code",
  props: ["replaceNodes", "code"],
  data: () => ({ scriptsInserted: [], scriptsRun: [] }),
  mounted() {
    this.findAndRunScripts();
  },
  methods: {
    findAndRunScripts() {
      if (this.$refs.elem && this.$refs.elem.getElementsByTagName && typeof window < "u") {
        const t = this.$refs.elem.getElementsByTagName("script");
        for (let e = 0; e < t.length; e++) {
          const n = t[e];
          if (n.src) {
            if (this.scriptsInserted.includes(n.src))
              continue;
            this.scriptsInserted.push(n.src);
            const o = document.createElement("script");
            o.async = !0, o.src = n.src, document.head.appendChild(o);
          } else if (!n.type || [
            "text/javascript",
            "application/javascript",
            "application/ecmascript"
          ].includes(n.type)) {
            if (this.scriptsRun.includes(n.innerText))
              continue;
            try {
              this.scriptsRun.push(n.innerText), new Function(n.innerText)();
            } catch (o) {
              console.warn("`CustomCode`: Error running script:", o);
            }
          }
        }
      }
    },
    _classStringToObject(t) {
      const e = {};
      if (typeof t != "string")
        return e;
      const n = t.trim().split(/\s+/);
      for (const o of n)
        e[o] = !0;
      return e;
    }
  }
};
var wt = function() {
  var e = this, n = e._self._c;
  return n("div", { ref: "elem", class: e._classStringToObject(
    "builder-custom-code" + (e.replaceNodes ? " replace-nodes" : "")
  ), domProps: { innerHTML: e._s(e.code) } });
}, St = [], It = /* @__PURE__ */ p(
  kt,
  wt,
  St,
  !1,
  null,
  null,
  null,
  null
);
const Tt = It.exports, Rt = {
  name: "Custom Code",
  static: !0,
  builtIn: !0,
  requiredPermissions: ["editCode"],
  inputs: [
    {
      name: "code",
      type: "html",
      required: !0,
      defaultValue: "<p>Hello there, I am custom HTML code!</p>",
      code: !0
    },
    {
      name: "replaceNodes",
      type: "boolean",
      helperText: "Preserve server rendered dom nodes",
      advanced: !0
    },
    {
      name: "scriptsClientOnly",
      type: "boolean",
      defaultValue: !1,
      helperText: "Only print and run scripts on the client. Important when scripts influence DOM that could be replaced when client loads",
      advanced: !0
    }
  ]
}, $t = () => [
  { component: Q, ...tt },
  { component: re, ...ot },
  { component: xt, ...Ct },
  { component: de, ...at },
  { component: fe, ...it },
  { component: We, ...rt },
  { component: He, ...et },
  { component: Je, ...st },
  { component: Ze, ...nt },
  { component: ft, ...ct },
  { component: Tt, ...Rt }
];
function R({
  code: t,
  context: e,
  state: n,
  event: o
}) {
  if (t === "") {
    console.warn("Skipping evaluation of empty code block.");
    return;
  }
  const s = {
    isEditing: f(),
    isBrowser: u(),
    isServer: !u()
  }, a = !(t.includes(";") || t.includes(" return ") || t.trim().startsWith("return ")) ? `return (${t});` : t;
  try {
    return new Function(
      "builder",
      "Builder",
      "state",
      "context",
      "event",
      a
    )(s, s, n, e, o);
  } catch (c) {
    console.warn(
      `Builder custom code error: 
 While Evaluating: 
 `,
      a,
      `
`,
      c.message || c
    );
  }
}
function Et() {
  return !u() || f() ? !1 : Boolean(location.search.indexOf("builder.preview=") !== -1);
}
const O = (t) => JSON.parse(JSON.stringify(t)), P = [];
function ln(t, e) {
  return P.push({ component: t, ...e }), console.warn(
    "registerComponent is deprecated. Use the `customComponents` prop in RenderContent instead to provide your custom components to the builder SDK."
  ), t;
}
const Ft = ({
  component: t,
  ...e
}) => ({
  type: "builder.registerComponent",
  data: Vt(e)
}), jt = (t) => typeof t == "function" ? Ut(t) : O(t), Ut = (t) => {
  const e = t.toString().trim();
  return `return (${!e.startsWith("function") && !e.startsWith("(") ? "function " : ""}${e}).apply(this, arguments)`;
}, Vt = ({
  inputs: t,
  ...e
}) => ({
  ...O(e),
  inputs: t == null ? void 0 : t.map(
    (n) => Object.entries(n).reduce(
      (o, [s, r]) => ({
        ...o,
        [s]: jt(r)
      }),
      {}
    )
  )
});
function At() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(t) {
    const e = Math.random() * 16 | 0;
    return (t == "x" ? e : e & 3 | 8).toString(16);
  });
}
function W() {
  return At().replace(/-/g, "");
}
const B = "builderSessionId", Ot = async ({ canTrack: t }) => {
  if (!t)
    return;
  const e = await j({
    name: B,
    canTrack: t
  });
  if (g(e))
    return e;
  {
    const n = Pt();
    Wt({ id: n, canTrack: t });
  }
}, Pt = () => W(), Wt = ({
  id: t,
  canTrack: e
}) => U({ name: B, value: t, canTrack: e }), L = () => u() && typeof localStorage < "u" ? localStorage : void 0, Bt = ({
  key: t,
  canTrack: e
}) => {
  var n;
  try {
    return e ? (n = L()) == null ? void 0 : n.getItem(t) : void 0;
  } catch (o) {
    console.debug("[LocalStorage] GET error: ", o);
  }
}, Lt = ({
  key: t,
  canTrack: e,
  value: n
}) => {
  var o;
  try {
    e && ((o = L()) == null || o.setItem(t, n));
  } catch (s) {
    console.debug("[LocalStorage] SET error: ", s);
  }
}, M = "builderVisitorId", Mt = ({ canTrack: t }) => {
  if (!t)
    return;
  const e = Bt({
    key: M,
    canTrack: t
  });
  if (g(e))
    return e;
  {
    const n = Nt();
    Ht({ id: n, canTrack: t });
  }
}, Nt = () => W(), Ht = ({
  id: t,
  canTrack: e
}) => Lt({
  key: M,
  value: t,
  canTrack: e
}), zt = async ({
  canTrack: t
}) => {
  if (!t)
    return { visitorId: void 0, sessionId: void 0 };
  const e = await Ot({ canTrack: t }), n = Mt({ canTrack: t });
  return {
    sessionId: e,
    visitorId: n
  };
}, qt = async ({
  type: t,
  canTrack: e,
  apiKey: n,
  metadata: o,
  ...s
}) => ({
  type: t,
  data: {
    ...s,
    metadata: JSON.stringify(o),
    ...await zt({ canTrack: e }),
    ownerId: n
  }
});
async function _(t) {
  if (!!t.canTrack && !f() && !!(u() || y === "reactNative"))
    return fetch("https://builder.io/api/v1/track", {
      method: "POST",
      body: JSON.stringify({
        events: [await qt(t)]
      }),
      headers: {
        "content-type": "application/json"
      },
      mode: "cors"
    }).catch((e) => {
      console.error("Failed to track: ", e);
    });
}
const dn = (t) => _({ ...t, canTrack: !0 }), Kt = () => Promise.resolve().then(() => N).then((t) => t.default).catch((t) => {
  throw console.error(
    "Error while attempting to dynamically import component RenderBlocks at ../render-blocks.vue",
    t
  ), t;
}), Dt = () => import("./render-styles.6722cee5.js").then((t) => t.default).catch((t) => {
  throw console.error(
    "Error while attempting to dynamically import component RenderContentStyles at ./components/render-styles.vue",
    t
  ), t;
}), Jt = {
  name: "render-content",
  components: {
    RenderContentStyles: Dt,
    RenderBlocks: Kt
  },
  props: [
    "content",
    "data",
    "canTrack",
    "context",
    "customComponents",
    "model",
    "apiKey"
  ],
  data: () => ({
    forceReRenderCount: 0,
    overrideContent: null,
    update: 0,
    overrideState: {},
    markMutable: x
  }),
  provide() {
    const t = this;
    return {
      BuilderContext: {
        get content() {
          return t.useContent;
        },
        get state() {
          return t.contentState;
        },
        get context() {
          return t.contextContext;
        },
        get apiKey() {
          return t.apiKey;
        },
        get registeredComponents() {
          return t.allRegisteredComponents;
        }
      }
    };
  },
  mounted() {
    var t, e;
    if (u()) {
      if (f() && (this.forceReRenderCount = this.forceReRenderCount + 1, q(), K(), Object.values(this.allRegisteredComponents).forEach(
        (n) => {
          var s;
          const o = Ft(n);
          (s = window.parent) == null || s.postMessage(o, "*");
        }
      ), window.addEventListener("message", this.processMessage), window.addEventListener(
        "builder:component:stateChangeListenerActivated",
        this.emitStateUpdate
      )), this.useContent) {
        const n = (t = this.useContent) == null ? void 0 : t.testVariationId, o = (e = this.useContent) == null ? void 0 : e.id;
        _({
          type: "impression",
          canTrack: this.canTrackToUse,
          contentId: o,
          apiKey: this.apiKey,
          variationId: n !== o ? n : void 0
        });
      }
      if (Et()) {
        const n = new URL(location.href).searchParams;
        if (this.model && n.get("builder.preview") === this.model) {
          const o = n.get("apiKey") || n.get("builder.space");
          o && A({
            model: this.model,
            apiKey: o
          }).then((s) => {
            s && (this.overrideContent = s);
          });
        }
      }
      this.evaluateJsCode(), this.runHttpRequests(), this.emitStateUpdate();
    }
  },
  watch: {
    onUpdateHook0() {
      this.evaluateJsCode();
    },
    onUpdateHook1() {
      this.runHttpRequests();
    },
    onUpdateHook2() {
      this.emitStateUpdate();
    }
  },
  unmounted() {
    u() && (window.removeEventListener("message", this.processMessage), window.removeEventListener(
      "builder:component:stateChangeListenerActivated",
      this.emitStateUpdate
    ));
  },
  computed: {
    useContent() {
      var e, n;
      return !this.content && !this.overrideContent ? void 0 : {
        ...this.content,
        ...this.overrideContent,
        data: {
          ...(e = this.content) == null ? void 0 : e.data,
          ...this.data,
          ...(n = this.overrideContent) == null ? void 0 : n.data
        }
      };
    },
    canTrackToUse() {
      return this.canTrack || !0;
    },
    contentState() {
      var t, e;
      return {
        ...(e = (t = this.content) == null ? void 0 : t.data) == null ? void 0 : e.state,
        ...this.data,
        ...this.overrideState
      };
    },
    contextContext() {
      return this.context || {};
    },
    allRegisteredComponents() {
      return [
        ...$t(),
        ...P,
        ...this.customComponents || []
      ].reduce(
        (n, o) => ({
          ...n,
          [o.name]: o
        }),
        {}
      );
    },
    httpReqsData() {
      return {};
    },
    shouldRenderContentStyles() {
      var t, e, n, o, s;
      return Boolean(
        (((e = (t = this.useContent) == null ? void 0 : t.data) == null ? void 0 : e.cssCode) || ((s = (o = (n = this.useContent) == null ? void 0 : n.data) == null ? void 0 : o.customFonts) == null ? void 0 : s.length)) && y !== "reactNative"
      );
    },
    onUpdateHook0() {
      var t, e;
      return {
        0: (e = (t = this.useContent) == null ? void 0 : t.data) == null ? void 0 : e.jsCode
      };
    },
    onUpdateHook1() {
      var t, e;
      return {
        0: (e = (t = this.useContent) == null ? void 0 : t.data) == null ? void 0 : e.httpRequests
      };
    },
    onUpdateHook2() {
      return {
        0: this.contentState
      };
    }
  },
  methods: {
    processMessage(t) {
      const { data: e } = t;
      if (e)
        switch (e.type) {
          case "builder.contentUpdate": {
            const n = e.data, o = n.key || n.alias || n.entry || n.modelName, s = n.data;
            o === this.model && (this.overrideContent = s, this.forceReRenderCount = this.forceReRenderCount + 1);
            break;
          }
        }
    },
    evaluateJsCode() {
      var e, n;
      const t = (n = (e = this.useContent) == null ? void 0 : e.data) == null ? void 0 : n.jsCode;
      t && R({
        code: t,
        context: this.contextContext,
        state: this.contentState
      });
    },
    onClick(t) {
      var e, n;
      if (this.useContent) {
        const o = (e = this.useContent) == null ? void 0 : e.testVariationId, s = (n = this.useContent) == null ? void 0 : n.id;
        _({
          type: "click",
          canTrack: this.canTrackToUse,
          contentId: s,
          apiKey: this.apiKey,
          variationId: o !== s ? o : void 0
        });
      }
    },
    evalExpression(t) {
      return t.replace(
        /{{([^}]+)}}/g,
        (e, n) => R({
          code: n,
          context: this.contextContext,
          state: this.contentState
        })
      );
    },
    handleRequest({ url: t, key: e }) {
      F().then((n) => n(t)).then((n) => n.json()).then((n) => {
        const o = {
          ...this.overrideState,
          [e]: n
        };
        this.overrideState = o;
      }).catch((n) => {
        console.log("error fetching dynamic data", t, n);
      });
    },
    runHttpRequests() {
      var e, n, o;
      const t = (o = (n = (e = this.useContent) == null ? void 0 : e.data) == null ? void 0 : n.httpRequests) != null ? o : {};
      Object.entries(t).forEach(([s, r]) => {
        if (r && (!this.httpReqsData[s] || f())) {
          const a = this.evalExpression(r);
          this.handleRequest({
            url: a,
            key: s
          });
        }
      });
    },
    emitStateUpdate() {
      f() && window.dispatchEvent(
        new CustomEvent("builder:component:stateChange", {
          detail: {
            state: this.contentState,
            ref: {
              name: this.model
            }
          }
        })
      );
    }
  }
};
var Gt = function() {
  var o, s, r, a, c, i, l;
  var e = this, n = e._self._c;
  return e.useContent ? n("div", { ref: "elementRef", attrs: { "builder-content-id": (o = e.useContent) == null ? void 0 : o.id, "builder-model": e.model }, on: { click: function(d) {
    return e.onClick(d);
  } } }, [e.shouldRenderContentStyles ? [n("render-content-styles", { attrs: { cssCode: (r = (s = e.useContent) == null ? void 0 : s.data) == null ? void 0 : r.cssCode, customFonts: (c = (a = e.useContent) == null ? void 0 : a.data) == null ? void 0 : c.customFonts } })] : e._e(), n("render-blocks", { key: e.forceReRenderCount, attrs: { blocks: e.markMutable((l = (i = e.useContent) == null ? void 0 : i.data) == null ? void 0 : l.blocks) } })], 2) : e._e();
}, Xt = [], Yt = /* @__PURE__ */ p(
  Jt,
  Gt,
  Xt,
  !1,
  null,
  null,
  null,
  null
);
const Qt = Yt.exports, Zt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Qt
}, Symbol.toStringTag, { value: "Module" })), en = () => import("./block-styles.fc09dcaf.js").then((t) => t.default).catch((t) => {
  throw console.error(
    "Error while attempting to dynamically import component BlockStyles at ./render-block/block-styles.vue",
    t
  ), t;
}), tn = () => import("./render-block.089abc43.js").then((t) => t.default).catch((t) => {
  throw console.error(
    "Error while attempting to dynamically import component RenderBlock at ./render-block/render-block.vue",
    t
  ), t;
}), nn = {
  name: "render-blocks",
  components: { RenderBlock: tn, BlockStyles: en },
  props: ["blocks", "parent", "path", "styleProp"],
  inject: {
    builderContext: "BuilderContext"
  },
  computed: {
    className() {
      var t;
      return "builder-blocks" + ((t = this.blocks) != null && t.length ? "" : " no-blocks");
    }
  },
  methods: {
    onClick() {
      var t, e;
      f() && !((t = this.blocks) != null && t.length) && ((e = window.parent) == null || e.postMessage(
        {
          type: "builder.clickEmptyBlocks",
          data: {
            parentElementId: this.parent,
            dataPath: this.path
          }
        },
        "*"
      ));
    },
    onMouseEnter() {
      var t, e;
      f() && !((t = this.blocks) != null && t.length) && ((e = window.parent) == null || e.postMessage(
        {
          type: "builder.hoverEmptyBlocks",
          data: {
            parentElementId: this.parent,
            dataPath: this.path
          }
        },
        "*"
      ));
    },
    _classStringToObject(t) {
      const e = {};
      if (typeof t != "string")
        return e;
      const n = t.trim().split(/\s+/);
      for (const o of n)
        e[o] = !0;
      return e;
    }
  }
};
var on = function() {
  var e = this, n = e._self._c;
  return n("div", { class: e._classStringToObject(e.className + " div-23e8fqt91nf"), style: e.styleProp, attrs: { "builder-path": e.path, "builder-parent-id": e.parent, dataSet: {
    class: e.className
  } }, on: { click: function(o) {
    return e.onClick();
  }, mouseenter: function(o) {
    return e.onMouseEnter();
  } } }, [e.blocks ? e._l(e.blocks, function(o, s) {
    return n("render-block", { key: "render-block-" + o.id, attrs: { block: o, context: e.builderContext } });
  }) : e._e(), e.blocks ? e._l(e.blocks, function(o, s) {
    return n("block-styles", { key: "block-style-" + o.id, attrs: { block: o, context: e.builderContext } });
  }) : e._e()], 2);
}, sn = [], rn = /* @__PURE__ */ p(
  nn,
  on,
  sn,
  !1,
  null,
  "713efc9e",
  null,
  null
);
const an = rn.exports, N = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: an
}, Symbol.toStringTag, { value: "Module" })), $ = {};
function un(t) {
  if (u()) {
    Object.assign($, t);
    const e = {
      type: "builder.settingsChange",
      data: $
    };
    parent.postMessage(e, "*");
  }
}
export {
  He as B,
  Q as C,
  Ze as F,
  re as I,
  We as S,
  y as T,
  fe as V,
  de as a,
  Je as b,
  an as c,
  Et as d,
  R as e,
  O as f,
  P as g,
  ln as h,
  f as i,
  Ft as j,
  z as k,
  A as l,
  cn as m,
  p as n,
  Fe as o,
  je as p,
  ge as q,
  Qt as r,
  un as s,
  dn as t,
  be as u,
  ve as v,
  E as w
};
